import "core-js/modules/es6.function.name";

/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-18 13:56:55
 * @FilePath: \heshan_web\src\permission.js
 */

/**
 * 全站权限配置
 *
 */
import router from "./router/router";
import store from "./store";
import { validatenull } from '@/util/validate';
import { getToken, getRefreshToken } from '@/util/auth';
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

NProgress.configure({
  showSpinner: false
});
var lockPage = store.getters.website.lockPage; //锁屏页

router.beforeEach(function (to, from, next) {
  var meta = to.meta || {};
  var isMenu = meta.menu === undefined ? to.query.menu : meta.menu;
  store.commit('SET_IS_MENU', isMenu === undefined);

  if (getToken()) {
    if (store.getters.isLock && to.path !== lockPage) {
      //如果系统激活锁屏，全部跳转到锁屏页
      next({
        path: lockPage
      });
    } else if (to.path === '/login') {
      //如果登录成功访问登录页跳转到主页
      next({
        path: '/'
      });
    } else {
      //如果用户信息为空则获取用户信息，获取用户信息失败，跳转到登录页
      if (store.getters.token.length === 0) {
        store.dispatch('FedLogOut').then(function () {
          next({
            path: '/login'
          });
        });
      } else {
        var value = to.query.src || to.fullPath;
        var label = to.query.name || to.name;

        var _meta = to.meta || router.$avueRouter.meta || {};

        var i18n = to.query.i18n;

        if (_meta.isTab !== false && !validatenull(value) && !validatenull(label)) {
          store.commit('ADD_TAG', {
            label: label,
            value: value,
            params: to.params,
            query: to.query,
            meta: function () {
              if (!i18n) {
                return _meta;
              }

              return {
                i18n: i18n
              };
            }(),
            group: router.$avueRouter.group || []
          });
        }

        next();
      }
    }
  } else {
    //判断是否需要认证，没有登录访问去登录页
    if (meta.isAuth === false) {
      next();
    } else {
      next('/login');
    }
  }
});
router.afterEach(function () {
  NProgress.done();
  var title = store.getters.tag.label;
  var i18n = store.getters.tag.meta.i18n;
  title = router.$avueRouter.generateTitle(title, i18n); //根据当前的标签也获取label的值动态设置浏览器标题

  router.$avueRouter.setTitle(title);
});